import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import {
    emotionTransform,
    MantineEmotionProvider,
} from '@mantine/emotion';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { theme } from './theme'; // adjust the import path as needed

ReactDOM.createRoot(document.getElementById('root')!).render(
    <MantineProvider
        stylesTransform={emotionTransform}
        theme={theme}
    >
        <MantineEmotionProvider>
            <Notifications />
            <App />
        </MantineEmotionProvider>
    </MantineProvider>
)
